import * as React from 'react'

function SvgCart(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width="1.33em" height="1em" {...props}>
			<path
				fill="currentColor"
				d="M19.2 0l-.594 1.6h-1.544l-2.779 9.6H3.692l-.671-1.6h10.077L15.844 0zM2.35 8L0 2.4h13.45L11.87 8zM12 13.2a1.2 1.2 0 11-2.4 0 1.2 1.2 0 012.4 0zm-4 0a1.2 1.2 0 11-2.4 0 1.2 1.2 0 012.4 0z"
			/>
		</svg>
	)
}

export default SvgCart
